<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>토목</h3>
                            <div class="h6 mt-4">
                                토목 분야에서 지속 가능한 인프라를 구축하고, 도시 환경의 발전에 기여하고 있습니다.
                            </div>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <div class="row justify-content-center">
                                <div class="row col-lg-12" style="display: flex;">
                                    <div class="col-lg-6 card-div">
                                        <img src="img/theme/outdoor3.png" width="100%">
                                    </div>
                                    <div class="col-lg-6 card-div">
                                        <div>
                                            <p>
                                                &nbsp;&nbsp;다옴토건은 토목 분야에서의 전문성을 바탕으로 다양한 규모와 종류의 건설 프로젝트를 수행해 왔습니다. 
                                                <br><br>&nbsp;&nbsp;고객의 요구를 충족시키기 위해 최신 기술과 전문 지식을 적용하며, 안전성과 효율성을 동시에 고려한 설계와 시공을 지향합니다. 
                                                <br><br>&nbsp;&nbsp;다옴토건은 공공 및 민간부문에서의 다양한 프로젝트에서 경험을 쌓아왔으며, 고객의 비즈니스 성공을 위한 신뢰할 수 있는 파트너가 되기 위해 최선을 다하고 있습니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="text-center mt-5">
                                <h3>대표공사실적</h3>
                            </div>
                            <div class="row card-header-bus">
                                <img src="img/theme/main6.png" style="width: 100%;">
                                <div style="background-color: #000000e3; width: 100%; padding: 30px; text-align: left;">
                                    <div class="font-20">가양대교</div>
                                    <div class="font-15">위치 : 서울시 강서구 가양동 가양대교 14</div>
                                    <div class="font-15">사업내용 : 도로증축 (L=4.62km, 교량 9개소 1,502m, 터널 1개소 389m, 출입시설 2개소)</div>
                                </div>
                            </div>
                            <div class="text-center mt-5" style="margin-bottom: 20px;">
                                <h3 style="font-weight: 300;">주요공사실적</h3>
                            </div>
                            <div style="border: 1px solid black">
                                <ul class="ul">
                                    <li>· 공항동 주차장 포장공사</li>
                                    <li>· 서초그린파킹 주차장 공사</li>
                                    <li>· 중부시장 도로환경 개선공사</li>
                                    <li>· 서울보호관찰소 청사 보도블럭 교체공사</li>
                                    <li>· 금천구 임시공영 주차장 조성공사</li>
                                    <li>· 중산고등학교 주차장 설치공사</li>
                                    <li>· 용산 주상복합 신축공사</li>
                                    <li>· 경정장 경주시설 보수공사</li>
                                    <li>· 경정장 경수수면 결빙방지장치 설치공사</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {};
</script>
<style>
.line {
    border-bottom: 1px solid #e9ecef;
    padding-bottom: 40px;
    margin-bottom:  40px;
}

.mid-line{
    border-bottom: 3px solid black;
    width: 40px;
    border-radius: 1em;
    margin-bottom: 30px;
}

.header-text{
    font-size: 25px;
    font-weight: 300;
    padding-bottom: 10px;
}

.card-div{
    height: 300px;
    padding: 0px 30px 0px 30px;
}

.card-header-bus{
    color:#FFF; 
    font-weight: 300;
    padding: 60px 0 60px 0;
    display: flex;
    justify-content: center;
    background-color: #FFF;
}

.bg-white-gray{
    background-color: #f3f3f3;
}

.ul{
    display: block;
}
.ul > li{
    display: inline-block;
    position: relative;
    font-size: 15px;
    color: #666;
    padding-left: 10px;
    display: inline-block;
    width: 300px;
    vertical-align: top;
    margin: 10px 0;
}

.font-20{
    font-size: 20px;
}
.font-15{
    font-size: 15px;
}
</style>
